import axios from 'axios';

export const UNIT_PATH = '/api/units';
export const UNIT_SERVICE_ORDERS_PATH_ENDING = '/service-orders';
const QUICK_ACTION_PATH = '/quick-actions';
const REPAIR_CONTACT_PATH_ENDING = '/repair-contact';

class RepairContactService {
  async getRepairContact(params) {
    const url = `${UNIT_PATH}/${encodeURIComponent(
      params.unitId
    )}${UNIT_SERVICE_ORDERS_PATH_ENDING}/${encodeURIComponent(
      params.serviceOrderId
    )}${QUICK_ACTION_PATH}/${encodeURIComponent(params.customerId)}${REPAIR_CONTACT_PATH_ENDING}/${encodeURIComponent(
      params.repairContactId
    )}`;
    const repairContact = await axios.get(url);
    return repairContact;
  }

  async updateRepairContact(unitId, serviceOrderId, customerId, repairContact) {
    const url = `${UNIT_PATH}/${encodeURIComponent(unitId)}/${UNIT_SERVICE_ORDERS_PATH_ENDING}/${encodeURIComponent(
      serviceOrderId
    )}/${QUICK_ACTION_PATH}/${REPAIR_CONTACT_PATH_ENDING}/${encodeURIComponent(customerId)}`;
    const updatedRepairContact = await axios.post(url, repairContact);
    return updatedRepairContact;
  }
}

export default new RepairContactService();
